import React, { useEffect, useState } from "react";

import Modeler from "./containers/smart/camunda/modeler";
import StandaloneFormBuilder from "./containers/StandaloneFormBuilder";
import "./theme/css/app.css";
import Provider from "./Provider";
import SendMessage from "./util/message";

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const isFormBuilder = urlParams.get("builder") === "1";

  const [isSetupDone, setIsSetupDone] = useState(!isFormBuilder);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      window.parent.postMessage(
        { size: `${document.documentElement.scrollHeight}px` },
        "*",
      );
    });

    resizeObserver.observe(document.documentElement);

    const handleMessage = async ({ data: event }) => {
      if (event.message === "setup") {
        if (event.data?.token)
          sessionStorage.setItem("token", event.data.token);
        if (event.data?.tenant)
          sessionStorage.setItem("tenant", event.data.tenant);
        if (event.data?.baseUrl)
          sessionStorage.setItem("baseUrl", event.data.baseUrl);
        window.dispatchEvent(new Event("token_updated"));
        setIsSetupDone(true);
      }
    };

    window.addEventListener("message", handleMessage);

    SendMessage({ status: "load_complete" });

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  if (!isSetupDone) {
    return null;
  }

  return (
    <Provider>
      {isFormBuilder ? <StandaloneFormBuilder /> : <Modeler />}
    </Provider>
  );
}

export default App;
